function MenuHeader() {
    return (
        <div className="header">
            <h1>Menu</h1>
            <hr className="headerRod" />
        </div>
    );
}

export default MenuHeader;